import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { VENTAS_DESVINCULARANTICIPO_LISTA } from 'constants/codigosTransacciones'

import ListaPage  from './lista'

export default function VentasDesvincularAnticipoPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${VENTAS_DESVINCULARANTICIPO_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}

